import React from 'react';

import { Button } from 'src/routes/client/components/common';
import { useTranslation } from 'client/hooks';

import goForIsraelBigLogo from 'client/assets/goforisrael-big.svg';

import css from './SchedulePopup.module.scss';

interface Props {
  onClose?: () => void;
}

export const SuccessMessage: React.FC<Props> = ({ onClose }) => {
  const { translate: _t } = useTranslation('popups');

  return (
    <div className={css.successMessage}>
      <div className={css.goForIsraelBigLogo}>
        <img src={goForIsraelBigLogo} alt="go for Israel" />
      </div>
      <div className={css.successMessageTitle}>{_t('schedulePopup.successMessages.title')}</div>
      <div className={css.successMessageInfo}>{_t('schedulePopup.successMessages.subTitle')}</div>
      <Button onClick={onClose} className={css.successMessageButton}>
        {_t('schedulePopup.successMessages.btnLabel')}
      </Button>
    </div>
  );
};
